/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Andrii Titkov",
  title: "Hi all, I'm Andrii",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 with hands-on experience in building modern Web and Mobile applications using JavaScript, TypeScript, React.js, Node.js, Python, and MongoDB, along with a range of other powerful tools and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/uc?export=download&id=1xHAQEo6wxA0iyNsSOka6K1E4qpqgUf1D", // Direct download link for your resume
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/AJoker0",
  linkedin: "https://www.linkedin.com/in/andrii-titkov-dev/",
  gmail: "andrii.titkov@gmail.com",
  gitlab: "https://gitlab.com/",
  facebook: "https://www.facebook.com/profile.php?id=100021743444362",
  instagram: "https://www.instagram.com/titkov_andrii/",
  stackoverflow: "https://stackoverflow.com/users/28266276/andrii",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji(
      "⚡ I create Progressive Web Apps (PWA) with smooth performance in both traditional and SPA setups."
    ),
    emoji(
      "⚡ I connect apps to services like Firebase, AWS, and DigitalOcean, ensuring they scale and stay reliable."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "devicon-html5-plain colored"
    },

    {
      skillName: "TypeScript",
      fontAwesomeClassname: "devicon-typescript-plain colored"
    },

    {
      skillName: "css3",
      fontAwesomeClassname: "devicon-css3-plain colored"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "devicon-sass-original colored"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "devicon-javascript-plain colored"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "devicon-react-original colored"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "devicon-nodejs-plain colored"
    },
    /*{
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },*/
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "devicon-python-plain colored"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "devicon-docker-plain colored"
    },
    {
      skillName: "mongodb",
      fontAwesomeClassname: "devicon-mongodb-plain colored"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Varna University of Management",
      logo: require("./assets/images/varna-uni.png"),
      subHeader: "Bachelor of Software Engineering",
      duration: "September 2024 - August 2027",
      desc: "Worked on real-world software projects, contributing to codebases and collaborating with peers.",
      descBullets: [
        "💻 Built several full-stack applications using TypeScript, Node.js, MongoDB and PHP",
        "📚 Continued self-study through platforms like Coursera and freeCodeCamp"
      ]
    },
    {
      schoolName: "Hillel IT School",
      logo: require("./assets/images/hillel-it.png"),
      subHeader: "Course (HTML, CSS, JavaScript)",
      duration: "June 2022 - August 2022",
      desc: "Completed certified web development course. Built responsive hiking website as final project.",
      descBullets: ["💻 Built several projects using HTML, CSS, and JavaScript"]
    },
    {
      schoolName: "freeCodeCamp",
      logo: require("./assets/images/freecodecamp.png"),
      subHeader: "Course JavaScript Algorithms and Data Structures",
      duration: "July 2025 - November 2025",
      desc: "Completed certified web development course. Built responsive hiking website as final project.",
      descBullets: ["💻 Built several projects using HTML, CSS, and JavaScript"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend (React, HTML, CSS, TypeScript)", //Insert stack or technology you have experience in
      progressPercentage: "85%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend (Node.js, Express, REST, MongoDB)",
      progressPercentage: "75%"
    },
    {
      Stack: "Software/Dev Skills (Git, Clean Code, Algorithms, Testing)",
      progressPercentage: "67%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Full-Stack Developer",
      company: "Extramus",
      companylogo: require("./assets/images/extramusLogo.png"),
      date: "June 2025 – September 2025",
      desc: "Contributed to internal Laravel-based tools, including the Negombo project. Participated in team sprints, peer code reviews, and testing of new features.",
      descBullets: [
        "Worked on the Negombo project using Laravel, MySQL, and Blade templates",
        "Collaborated with senior developers to implement and test new features"
      ]
    },
    {
      role: "Full-Stack Developer",
      company: "Negombo",
      companylogo: require("./assets/images/negomboLogo.png"),
      date: "June 2025 – August 2025",
      desc: "Developed a feature-rich web app for managing digital records in Laravel.",
      descBullets: [
        "Created reusable Blade templates and implemented responsive UI",
        "Worked with MySQL database and optimized SQL queries",
        "Fixed logic on the payment page to dynamically adjust price based on the number of people",
        "Updated admin panel pricing logic and made additional UI/UX improvements"
      ]
    }
    /*{
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }*/
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle:
    "SOME PERSONAL PROJECTS I BUILT OR CONTRIBUTED TO AS A FULL-STACK DEVELOPER",
  projects: [
    {
      image: require("./assets/images/GPT_Image_1_Refine_the_existing_logo_design_for_VibeMap_to_mak_0.png"),
      projectName: "🗺️ VibeMap",
      projectDesc:
        "Real-time map that lets users explore and filter places and people based on mood, interests, and vibes.",
      descBullets: [
        "Tech: TypeScript, Next.js, Leaflet, Tailwind, Express.js, MongoDB"
      ],
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/AJoker0/vibemap"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/quickCV.png"),
      projectName: "🤖 QuickCV‑AI",
      projectDesc:
        "A smart app that helps users build professional resumes using AI suggestions. It generates text and layout suggestions based on user input.",
      descBullets: ["Tech: React, TypeScript, OpenAI API, Tailwind, Zustand"],
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/AJoker0/quickcv-ai"
        }
      ]
    },
    {
      image: require("./assets/images/images.png"),
      projectName: "⚽ Soccer Analytics Dashboard",
      projectDesc:
        "Analyzes football match data and displays dynamic graphs and performance indicators per team/player.",
      descBullets: [
        "Frontend: React, TypeScript, Tailwind CSS",
        "Backend/APIs: OpenAI API, Zustand",
        "Focus: Data visualization, performance analytics"
      ],
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/AJoker0/soccer_analytics_projectweek"
        }
      ]
    },
    {
      image: require("./assets/images/Flux_Dev_Create_a_modern_vibrant_logo_for_Quiz_Game__a_dynamic_0.jpg"),
      projectName: "❓ Quiz-Game",
      projectDesc:
        "Dynamic multiplayer quiz game with countdown timers, real-time scoring, detailed answer logs, and stylish UI. Built with JavaScript, HTML, and CSS for engaging gameplay.",
      descBullets: ["Tech: HTML, CSS, JavaScript"],
      footerLink: [
        {
          name: "Visit Website",
          url: "hhttps://github.com/AJoker0/quiz-game"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "BIP International BusIT Week",
      subtitle:
        "Collaborated in an interdisciplinary international team to develop AI-driven sports analytics using real data from OHL football club. Skills: OpenAI API, Machine Learning, Football Data, API Integration, Team Communication, Technical Presentations.",
      image: require("./assets/images/int_busit_week.png"),
      imageAlt: "Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.linkedin.com/in/andrii-titkov-dev/details/certifications/"
        },

        {
          name: "BIP International BusIT Week Blog",
          url: "https://www.ucll.be/en/programmes/short-programmes/international-weeks/busit"
        }
      ]
    },
    {
      title: " Front-End Certificate — Hillel IT School",
      subtitle:
        "Completed an intensive front-end web development course covering HTML, CSS, and JavaScript. Created interactive layouts and responsive web apps as part of final project.",
      image: require("./assets/images/hillel-it.png"),
      imageAlt: " Logo",
      footerLink: [
        {
          name: "Show Credential",
          url: "https://certificate.ithillel.ua/view/57765894"
        }
      ]
    },

    {
      title: "JavaScript Algorithms and Data Structures — freeCodeCamp",
      subtitle:
        "Will complete the official freeCodeCamp.org certification, covering modern JavaScript, ES6+, functional programming, and data structures. Includes 300+ coding challenges and multiple projects.",
      image: require("./assets/images/freecodecamp.png"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: ""
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://t.me/goitstudent",
      title:
        "How I Built QuickCV with OpenAI + React in a Weekend see in Telegram",
      description:
        "Sharing my workflow, mistakes, and architecture decisions for my AI-based resume builder."
    },
    {
      url: "https://www.linkedin.com/in/andrii-titkov-dev/",
      title: "🛠️ The Real-World Power of Side Projects",
      description:
        'What makes a side project "portfolio-ready"? I reflect on my journey from "code-along tutorials" to apps like Soccer Analytics Dashboard, with a focus on data visualization and OpenAI APIs.'
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I love to teach what I learn. Even if it's just two subscribers and my cat watching — I'm speaking anyway 🐻"
  ),

  talks: [
    {
      title: "JavaScript Essentials for Beginners",
      subtitle: "The full series is pinned in the channel",
      //slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://t.me/goitstudent"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Fun Fact: My lovely Song 🎙️"),
  subtitle:
    "When I’m not coding, I’m vibing to this. Yes, it's Morgenshtern. No regrets.",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://open.spotify.com/embed/track/3bMVSeSOCkppgrhNZYMxZy?utm_source=generator&theme=0"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "Contact with Email",
  email_address: "andrii.titkov@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
